export function forecastDateKey(date, offset = 0) {
  return new Date(new Date(date).getTime() + offset * 1000)
    .toISOString()
    .slice(0, 10);
}

export function forecastTime(date, offset = 0, options = { hour: 'numeric' }) {
  return new Intl.DateTimeFormat('en-US', {
    ...options,
    timeZone: 'UTC',
  }).format(new Date(new Date(date).getTime() + offset * 1000));
}

export function upcomingForecast(slots = [], now = new Date()) {
  const start = now.getTime();
  return slots.filter((slot) => {
    const time = new Date(slot.time).getTime();
    return time > start && time <= start + 24 * 60 * 60 * 1000;
  });
}

export function precipitationLabel(probability) {
  return Number.isFinite(probability) && probability >= 0 && probability <= 1
    ? `${Math.round(probability * 100)}%`
    : 'Unavailable';
}
